import type { FetchBaseQueryError } from "@reduxjs/toolkit/query"

export interface ICustomError {
  data: { message: string }
  status: number
}

export const isFetchBaseQueryError = (error: unknown): error is FetchBaseQueryError =>
  typeof error === "object" && error != null && "status" in error

// The editable features API answers 404 once backoffice turns the feature off.
export const isFeatureOff = (error: unknown) =>
  isFetchBaseQueryError(error) && error.status === 404
